<div style="padding: 2px 10px 10px 10px;color:black !important; height: 200px">
  <div class="row">
    <table class="table table-striped table-bordered table-hover table-condensed">
      <thead [ngClass]="{'theadcss': totalItems>16}">
        <!--<thead>-->
        <tr>
          <th style="width:40px;text-align:center;background-color:#f3f8fc">STT</th>
          <th style="min-width:130px;text-align:center;background-color:#f3f8fc">Nội dung</th>
          <th style="min-width:110px;text-align:center;background-color:#f3f8fc">Ngày tạo</th>
          <th style="min-width:110px;text-align:center;background-color:#f3f8fc">Người tạo</th>
          <th style="min-width:110px;text-align:center;background-color:#f3f8fc">Trạng thái</th>
          <th style="min-width:110px;text-align:center;background-color:#f3f8fc">Người nhận</th>
          <th style="min-width:110px;text-align:left;background-color:#f3f8fc">
            <!--Khóa học ĐK-->
          </th>


        </tr>

      </thead>
      <tbody style="height:150px">
        <tr *ngFor="let u of datas; let i = index" (click)="selected(u)">
          <td style="width:40px;text-align:center"><a>{{u.STT}}</a></td>
          
          <td style="min-width:130px"><a>{{u.NoiDung}}</a></td>
          <td style="min-width:110px"><a>{{u.Created | date:'dd/MM/yyyy'}}</a></td>
          <td style="min-width:110px"><a>{{u.CreatedBy}}</a></td>
          <td style="min-width:110px;font-weight:bold"><a>{{u.TrangThaiS}}</a></td>
          <td style="min-width:110px">
            {{u.NguoiNhanText}}
          </td>
          <td style="min-width:110px">
            <a title="Xóa dòng" (click)="deleterow(i)" style="margin-left:5px;cursor:pointer;color:#1e6bb8 !important" class="mb-1 far fa-trash-alt ng2-smart-action ng2-smart-action-custom-custom ng-star-inserted">Xóa dòng</a>
          </td>

        </tr>
      </tbody>
    </table>


  </div>

</div>

<div class="form-group row">
  <label class="control-label col-3">{{'Ngày tạo' | translate}}<span class="cred">(*)</span></label>
  <div class="col-3">
    <kendo-dateinput tabindex="1" style="width:100%;" [format]="'dd/MM/yyyy'" [(value)]="doituongSelect.Created"></kendo-dateinput>
  </div>
  <label class="control-label col-3 ng-binding">{{'Người tạo' | translate}}</label>
  <div class="col-3">
    <input type="text" tabIndex="2" class="form-control" placeholder="" disabled="disabled" [(ngModel)]="doituongSelect.CreatedBy">
  </div>
</div>


<!--<div class="row form-group">
  <label class="control-label col-4 ng-binding">{{'Số buổi' | translate}}</label>
  <div class="col-8">
    <input class="form-control"
           maxlength="20"
           tabindex="13"
           currencyMask
           [(ngModel)]="doituongSelect.SoBuoi"
           name="value"
           [placeholder]="''"
           [options]="ngxCurrencyOptions" autocomplete="off" />
  </div>
</div>-->





<div class="row form-group">
  <label class="control-label col-3">{{'Nội dung' | translate}}</label>
  <div class="col-9 required-field">
    <textarea type="text" tabindex="2" class="form-control" rows="3" [(ngModel)]="doituongSelect.NoiDung"></textarea>
  </div>
</div>

<div class="row form-group">
  <label class="control-label col-3">{{'Ghi chú' | translate}}</label>
  <div class="col-9 required-field">
    <textarea type="text" tabindex="3" class="form-control" rows="2" [(ngModel)]="doituongSelect.GhiChu"></textarea>
  </div>
</div>

<div class="row form-group">
  <label class="control-label col-3 ng-binding">{{'Người nhận' | translate}}</label>
  <div class="col-3">
    <ng-select #slLop
               class="twcollong"
               [multiple]="true"
               [tabIndex]="5"
               [openOnEnter]="false"
               [items]="dslops"
               bindValue="Id"
               bindLabel="Ten"
               placeholder="'Không chọn là tất cả nhân sự nhìn thấy'"
               notFoundText="Không có dữ liệu"
               [searchFn]="comboSearchFn2"
               [(ngModel)]="doituongSelect.DSNguoiNhan">
      <ng-template ng-option-tmp let-item="item">
        <div class="rTableRow">
          <div class="rTableCell_1">{{item.Ten}}</div>
        </div>
      </ng-template>
    </ng-select>
  </div>
  <label class="control-label col-3 ng-binding">{{'Trạng thái' | translate}}</label>
  <div class="col-3">
    <ng-select #slTrangthai
               class="twcollong"
               [tabIndex]="6"
               [openOnEnter]="false"
               [items]="dstrangthais"
               bindValue="Id"
               bindLabel="Ten"
               notFoundText="Không có dữ liệu"
               [searchFn]="comboSearchFn2"
               [(ngModel)]="doituongSelect.TrangThai">
      <ng-template ng-option-tmp let-item="item">
        <div class="rTableRow">
          <div class="rTableCell_1">{{item.Ten}}</div>
        </div>
      </ng-template>
    </ng-select>
  </div>
</div>



<div class="row form-group">

</div>

<div class="modal-footer" style="display: flex;justify-content: space-between;">
  <div style="display:flex;">
    <div class="checkbox c-checkbox">
      <label>
        <input tabIndex="20" type="checkbox" [(ngModel)]="TimKiems.HienThiTatCa" (ngModelChange)="onHienThiTatCaChange()"/>
        <span class="fa fa-check"></span> Hiển thị tất cả nhắc việc
      </label>
    </div>
  </div>
  <div class="">
    <button class="mb-1 mr-1 btn btn-secondary" (click)="closeModal()" title="Ấn ESC để thoát" style="padding-top:0px !important">Đóng lại</button>
    <button type="submit" (click)="ThucHien()" class="mb-1 mr-1 btn btn-primary" style="padding-top:0px !important">Lưu lại</button>
    <button type="submit" (click)="LamMoi()" class="mb-1 mr-1 btn btn-success" style="padding-top:0px !important">Làm mới</button>
  </div>

</div>


